import { useTranslation } from "react-i18next"
import ReactCountryFlag from "react-country-flag"
import { useSelector } from "react-redux"
import api from '@src/services/api'

import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap"

const langToLocale = {
  en: 'en',
  es: 'es',
  pt: 'pt_BR'
}

const IntlDropdown = () => {
  const { i18n, t } = useTranslation()
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)

  const langObj = {
    en: t("English"),
    es: t("Spanish"),
    pt: t("Portuguese")
  }

  const handleLangUpdate = async (e, lang) => {
    e.preventDefault()
    i18n.changeLanguage(lang)
    localStorage.setItem('userPreferredLanguage', lang)

    if (isAuthenticated) {
      try {
        const locale = langToLocale[lang] || 'en'
        await api.post('/i18n/locale', { locale })
      } catch (err) {
        // Silently fail - UI already changed
      }
    }
  }

  return (
    <UncontrolledDropdown
      href="/"
      tag="li"
      className="dropdown-language nav-item"
    >
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link"
        onClick={(e) => e.preventDefault()}
      >
        <ReactCountryFlag
          svg
          className="country-flag flag-icon"
          countryCode={i18n.language === "en" ? "us" : i18n.language === "pt" ? "br" : i18n.language}
        />
        <span className="selected-language">{langObj[i18n.language]}</span>
      </DropdownToggle>
      <DropdownMenu className="mt-0" end>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "en")}
        >
          <ReactCountryFlag className="country-flag" countryCode="us" svg />
          <span className="ms-1">{t("English")}</span>
        </DropdownItem>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "es")}
        >
          <ReactCountryFlag className="country-flag" countryCode="es" svg />
          <span className="ms-1">{t("Spanish")}</span>
        </DropdownItem>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "pt")}
        >
          <ReactCountryFlag className="country-flag" countryCode="br" svg />
          <span className="ms-1">{t("Portuguese")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default IntlDropdown
